export enum ScenesDisplay {
    Card = 'card',
    Grid = 'grid',
    Table = 'table',
}
